import {
	useWaitlistQuery,
	WaitlistFlowEnum,
} from 'common/waitlist/Waitlist.queries';
import Stack from 'components/Stack';
import Subtitle1 from 'components/Typography/Subtitle1';
import Title from 'components/Typography/Title';
import paths from 'constants/paths';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { rem } from 'styles';
import { SignupContainer } from './Signup.styles';
import SignupForm from './SignupForm';

const isWaitlistEnabled = process.env.NEXT_PUBLIC_WAITLIST_ENABLED === 'true';

const Signup = () => {
	const { spacings } = useTheme();

	const router = useRouter();
	const { query } = router;
	const hasReferralCode = !isEmpty(query.referralCode);

	const { data: waitlist } = useWaitlistQuery();

	useEffect(() => {
		if (
			!hasReferralCode &&
			isWaitlistEnabled &&
			waitlist?.flow === WaitlistFlowEnum.JOIN
		) {
			router.push(paths.root);
		}
	}, [waitlist?.flow, router, hasReferralCode]);

	return (
		<>
			<SignupContainer>
				<Stack gutter={spacings[40]}>
					<Stack gutter={spacings[20]}>
						<Title align='center'>Sign Up</Title>
						<Subtitle1
							align='center'
							style={{ maxWidth: rem(400), margin: 'auto' }}
						>
							Let's set you up as a user on Coinshift so you can create or join
							an organisation.
						</Subtitle1>
					</Stack>
					<SignupForm />
				</Stack>
			</SignupContainer>
		</>
	);
};

export default Signup;
